import _objectWithoutProperties from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectDestructuringEmpty from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
var _excluded = ["fillColor", "strokeColor", "strokeWidth", "size"];
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { withSubcomponents } from '../utils.js';
var Path = function Path(_ref) {
  var args = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx("path", _objectSpread({
      d: "M15.368 12.1649C17.4006 12.2003 18.925 9.24969 18.9061 9.23688C17.8074 10.3538 15.7346 10.5002 14.636 11.6159L15.368 12.1649Z"
    }, args)), /* @__PURE__ */jsx("path", _objectSpread({
      d: "M12.5009 13.385L14.087 12.2259C15.8578 14.4836 14.7836 16.5881 12.5619 17.655C13.5685 15.4999 14.237 15.4419 12.5009 13.385Z"
    }, args)), /* @__PURE__ */jsx("path", _objectSpread({
      d: "M11.2199 15.093C11.2199 15.7668 10.6737 16.313 9.99991 16.313C9.32611 16.313 8.77989 15.7668 8.77989 15.093C8.77989 14.4192 9.32611 13.873 9.99991 13.873C10.6737 13.873 11.2199 14.4192 11.2199 15.093Z"
    }, args)), /* @__PURE__ */jsx("path", _objectSpread({
      d: "M4.63199 12.1649C2.59943 12.2003 1.07501 9.24969 1.09392 9.23688C2.19255 10.3538 4.26537 10.5002 5.364 11.6159L4.63199 12.1649Z"
    }, args)), /* @__PURE__ */jsx("path", _objectSpread({
      d: "M7.49906 13.385L5.91303 12.2259C4.14217 14.4836 5.2164 16.5881 7.43806 17.655C6.43154 15.4999 5.76297 15.4419 7.49906 13.385Z"
    }, args)), /* @__PURE__ */jsx("path", _objectSpread({
      d: "M8.77989 15.093C8.77989 15.7668 9.32611 16.313 9.99991 16.313C10.6737 16.313 11.2199 15.7668 11.2199 15.093C11.2199 14.4192 10.6737 13.873 9.99991 13.873C9.32611 13.873 8.77989 14.4192 8.77989 15.093Z"
    }, args)), /* @__PURE__ */jsx("path", _objectSpread({
      d: "M13.782 2.34375C13.782 2.34375 15.1332 4.60445 14.758 6.18682C14.3798 7.78322 13.2915 8.71776 11.952 9.35888C10.6295 8.67629 9.37052 8.66961 8.04804 9.35888C6.70849 8.71776 5.62019 7.78319 5.24199 6.18682C4.86683 4.60445 6.21801 2.34375 6.21801 2.34375C5.26517 3.53022 4.23608 4.24821 3.89996 6.12582C3.48097 8.46818 5.8015 11.7082 8.04804 12.9496C9.37055 13.6389 10.6295 13.6322 11.952 12.9496C14.1985 11.7082 16.519 8.46818 16.1 6.12582C15.7639 4.24821 14.7348 3.53022 13.782 2.34375Z"
    }, args))]
  });
};
var ViewBox = "0 0 20 20";
var _Angel = forwardRef(function (_ref2, ref) {
  var _ref2$fillColor = _ref2.fillColor,
    fillColor = _ref2$fillColor === void 0 ? "#FFE1B0" : _ref2$fillColor,
    _ref2$strokeColor = _ref2.strokeColor,
    strokeColor = _ref2$strokeColor === void 0 ? "black" : _ref2$strokeColor,
    _ref2$strokeWidth = _ref2.strokeWidth,
    strokeWidth = _ref2$strokeWidth === void 0 ? 0 : _ref2$strokeWidth,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 28 : _ref2$size,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    width: size,
    height: size,
    viewBox: ViewBox,
    fill: "none",
    paintOrder: "stroke"
  }, rest), {}, {
    children: /* @__PURE__ */jsx(Path, {
      fill: fillColor,
      stroke: strokeColor,
      strokeWidth: strokeWidth
    })
  }));
});
_Angel.displayName = "Angel";
var Angel = withSubcomponents(_Angel, {
  Path: Path,
  ViewBox: ViewBox
});
export { Angel };